export default "__VITE_ASSET__c800de2b__"